import { z } from "zod";

export const NpmProxyTokenPayload = z.object({
  npmProxyRegistryConfigId: z.string(),
});

export type NpmProxyTokenPayload = z.infer<typeof NpmProxyTokenPayload>;
